import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaSearch, FaUserFriends } from 'react-icons/fa';
import { MdAdd, MdClose, MdDelete, MdEdit } from 'react-icons/md';
import styles from "./companiesAf.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalCompaniesAF from './companiesAfModal';



const customStyles = {
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#046cc2",
            fontSize: "15px",
            color: "white",
        },
    },


};
export default function CompañiasAF(props) {
    const { windowSize } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);
    const { estados, municipios, sucursales } = useAuth();
    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [textSearch, setTextSearch] = useState("");
    const [textSearchPrev, setTextSearchPrev] = useState("");

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
        },
        {
            name: 'Nombre',
            selector: row => row.name,
        },
        {
            name: 'Membresía',
            selector: row => row.membershipNumber,
        },
        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setUserEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.companyName, row.id)}><MdDelete /></button>
                    </div>
                )
            },
        }
    ];
    const handleGetOffice = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description,
                            stateId: element.stateId,
                            municipalityId: element.municipalityId
                        });

                    }
                }
                setOfices(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleDelete = (userName, userId) => {
        Swal.fire({
            title: "¿Esta segur@ que desea eliminar la empresa \"" + userName + "\"?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                let payload = {
                    userName: userName
                }
                api(SERVICE.deleteCompanieAf + `?id=${userId}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }

    const handleUpdate = () => {
        let URL = SERVICE.getCompanieAfGrid + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (textSearch != "") {
            URL = URL + `&TextSearch=${textSearch}`;
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        if (data && data.data && data.data.paginationInfo) {
                            setTotalRows(data.data.paginationInfo.totalRecords);
                        }
                        let arraySuc = [];
                        api(SERVICE.getCompanieSucAf + element.id)
                            .then((data) => {

                                if (data.data.data) {
                                    for (let index = 0; index < data.data.data.length; index++) {
                                        const sucursalCom = data.data.data[index];
                                        arraySuc.push({
                                            ...sucursalCom
                                        });
                                    }
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                        arrayTemp.push({
                            ...element,
                            sucursales: arraySuc
                        });

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdateNosearch = () => {
        let URL = SERVICE.getCompanieAfGrid + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        if (data && data.data && data.data.paginationInfo) {
                            setTotalRows(data.data.paginationInfo.totalRecords);
                        }
                        let arraySuc = [];
                        api(SERVICE.getCompanieSucAf + element.id)
                            .then((data) => {

                                if (data.data.data) {
                                    for (let index = 0; index < data.data.data.length; index++) {
                                        const sucursalCom = data.data.data[index];
                                        arraySuc.push({
                                            ...sucursalCom
                                        });
                                    }
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                        arrayTemp.push({
                            ...element,
                            sucursales: arraySuc
                        });

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    // const handleUpdateRoles = () => {

    //     api(SERVICE.getRoles)
    //         .then((data) => {
    //             let arrayTemp = [];
    //             for (let index = 0; index < data.data.data.length; index++) {
    //                 const element = data.data.data[index];
    //                 arrayTemp.push({
    //                     id: element.id,
    //                     identifier: element.identifier,
    //                     description: element.description
    //                 })
    //             }
    //             setRoles(arrayTemp);
    //         })
    //         .catch((err) => {

    //         })
    // }
    const ExpandedComponentSucursales = ({ data }) => {
        console.log("data", data);
        let array = [];
        if (data && data.sucursales && data.sucursales.length > 0) {
            for (let index = 0; index < data.sucursales.length; index++) {
                const element = data.sucursales[index];
                array.push(
                    <tr>
                        <td>{index + 1}</td>
                        <td>{element.stateName}</td>
                        <td>{element.municipalityName}</td>
                        <td>{element.description}</td>
                    </tr>
                );
            }
        }
        return (
            <div style={{ paddingLeft: "50px" }}>
                <div style={{ display: array.length > 0 ? "flex" : "none", justifyContent: "center", alignItems: "center", backgroundColor: "#69A3C3", color: "white" }}>Sucursales</div>
                <table class="table table-light" >
                    <tbody style={{ fontSize: "14px" }}>
                        {array}
                    </tbody>
                </table>
            </div>

        );
    };
    const alwaysExpanded = (row) => true;
   
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    useEffect(() => {
        if (ofices.length > 0) {
            handleUpdate();
        }
    }, [ofices, page, perPage])
    useEffect(() => {
        handleGetOffice();
    }, [])
    return (
        <>
            <WindowLayout
                title="EMPRESAS AFILIADAS"
                route={["Catálogos", "Empresas Afiliadas"]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerButtomTop}>
                        <button className='btn btn-sm btn-success' onClick={() => setShowModal(!showModal)}><FaPlus /></button>
                    </div>

                    <div class="input-group flex-nowrap" style={{ marginBottom: "10px", width: "500px" }}>
                        <input type="text" class="form-control" placeholder="Busqueda" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                        <button className='btn btn-primary' onClick={handleUpdate}><FaSearch /></button>
                    </div>
                    <div class="input-group flex-nowrap containerSearchPrev" style={{ display: textSearchPrev !== "" ? "flex" : "none" }}>
                        <div class="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={() => {
                            setTextSearch("");
                            setTextSearchPrev("");
                            handleUpdateNosearch();
                        }} className='divCloseSearch'><MdClose></MdClose></div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                        expandableRows
                        expandableRowsComponent={ExpandedComponentSucursales}
                    />

                </div>
            </WindowLayout>
            <ModalCompaniesAF
                show={showModal}
                setShow={setShowModal}
                ofices={ofices}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                handleUpdate={handleUpdate}
                estados={estados}
                municipios={municipios}
            />
        </>
    );
} 